// This is fun! The type definition for lodash's merge
// function uses overloads that provide type inference
// for up to five arguments. If you pass more than five,
// the overload treats the result as `any`.
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/88febcff5089238f997826d21cea65d81737d9f5/types/lodash/v3/index.d.ts#L13772-L13821
// In order to derives types from results of large merged
// objects, we need to provide our own type definition for
// _.merge that allows for type inference of an _actually_
// arbitrary number of arguments.
// Types are taken from https://stackoverflow.com/a/51603499
// and it's ok not to understand what they're dong.
// [A, B, C] -> A | B | C
import { merge as _merge } from "lodash";
/**
 * Lodash merge, but with fixed type definition.
 */
const merge = _merge;
export default merge;
